module.exports = __webpack_public_path__ + "media/angular-engine/app/guest/proceeed/placeholder-dc49736050e71129559cfd02122e735e.svg";